// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.settings-link {
  color: rgba(237, 109, 5);
  text-decoration: underline;
}
  `, "",{"version":3,"sources":["webpack://./src/app/services/permissions.service.ts"],"names":[],"mappings":";AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B","sourcesContent":["\n.settings-link {\n  color: rgba(237, 109, 5);\n  text-decoration: underline;\n}\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
